module.exports = __webpack_public_path__ + "img/9788997023080.11c23a58.jpg";